interface Props {
  className?: string
}

export function GoogleIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 533.5 544.3" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M533.5 278.4c0-18.5-1.6-37.1-5.1-55h-261v104.2h149.2c-6.2 33.6-25.5 62-54.4 81v67h87.9c51.4-47.4 83.4-117.3 83.4-197.2z" fill="#4285F4" />
      <path d="M267.5 544.3c73.6 0 135.3-24.2 180.4-65.8l-87.9-67c-24.4 16.4-55.6 25.9-92.5 25.9-70.9 0-131-47.8-152.5-112.1h-90v70.4c46.1 91.6 140.9 148.6 242.5 148.6z" fill="#34A853" />
      <path d="M115 325.3c-10.6-31.6-10.6-65.1 0-96.7V158.2h-90c-37.5 74.8-37.5 162.5 0 237.3l90-70.2z" fill="#FBBC05" />
      <path d="M267.5 106.1c38.8-.6 76.3 14.7 104.4 42.7l78-78C405 25.3 337.8-2.8 267.5 0 165.9 0 71.1 57 25 148.6l90 70.4c21.5-64.3 81.6-112.1 152.5-112.9z" fill="#EA4335" />
    </svg>
  )
}
